<template>
  <list
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="true"
    :isAdd="true"
    :itemLink="itemLink"
    :setLink="setLink"
    :openItem="false"
    :fields="fields"
    :searchDisable="true"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
  />
</template>
<script>
export default {
  name: "products",
  props: ["id"],
  created() {
    this.itemLink = `lessonplans/${this.id}/works`;
    this.setLink = `lessonplans/${this.id}/works`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "client_group",
      fields: [
        {
          col: "col-12 col-md-8",
          key: "title",
          label: "Название",
          type: "field",
          textType: "text",
        },

        {
          col: "col-12 col-md-4",
          key: "given_seconds",
          label: "Сколько секнуд на решение",
          type: "mask",
          mask: "###",
          textType: "number",
        },
        {
          col: "col-12 col-md-12",
          key: "description",
          label: "Краткое описание задания",
          type: "textarea",
          textType: "text",
        },
        // {
        //       col:'col-12 col-md-12',
        //       key: "is_time_limit",
        //       label: "Есть лимит времени",
        //       type: "checkbox",
        //  },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_work",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "title",
          title: "Задание",
          checkbox: false,
        },

        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
